import React, { useEffect, useState } from 'react'
import PieChartDiv from '../../../../../components/Rechart/PieChart'
import http from '../../../../../config/BaseUrl';

function PieChartComponent() {

  const [isLoading, setIsLoading] = useState(false);
  const [isNull, setCheckNull] = useState(false);
  const [dataCapture, setDataCapture] = useState([]);

  const fetchGraphDataCapturePie = async () => {
    try {
      setIsLoading(true)
      await http.get(`dashboard-graph/sharing-pie`).then(res => {
        let responseData = res.data.graphDataCapture

        if (responseData) {

          if (responseData.some(item => item.value > 0)) {
            setDataCapture(responseData)
            setCheckNull(true)
          }
          else {
            responseData.forEach(item => {
              return (
                item.defaultValue = 50
              )
            })
            setCheckNull(false)
            setDataCapture(responseData)
          }


          setIsLoading(false)
        }
      }).catch((err) => {
        setIsLoading(false)
      })
    } catch (error) {

    }
  }


  useEffect(() => {
    fetchGraphDataCapturePie()
  }, [])

  const data = [
    {
      name: "Prints",
      value: 3,
    },
    {
      name: "Text Messages",
      value: 2,
      pv: 967,
      amt: 1506,
      cnt: 590,
      background: 'rgba(140, 109, 57, .8)'
    },
    {
      name: "Email",
      value: 2,
      pv: 1098,
      amt: 989,
      cnt: 350,
      background: 'rgba(140, 109, 57, .8)'
    },
    {
      name: "Facebook",
      value: 2,
      pv: 1200,
      amt: 1228,
      cnt: 480,
      background: 'rgba(140, 109, 57, .8)'
    },
    {
      name: "Twitter",
      value: 2,
      pv: 1108,
      amt: 1100,
      cnt: 460,
      background: 'rgba(206,162,82,.8)'
    },
    {
      name: "Instagram",
      value: 2,
      pv: 680,
      amt: 1700,
      cnt: 380,
      background: 'rgba(206,162,82,.8)'
    }
  ];



  return (
    <div className="pie-chart">
      <h5 className="text-center mb-0">Social Sharing Stats</h5>
      <PieChartDiv loading={isLoading} dataSet={dataCapture && dataCapture} dataHasValue={isNull} />
    </div>
  )
}

export default PieChartComponent
